export default "__VITE_ASSET__84dbf772__"